import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-navy-deep" data-id="element-92" data-mp="9k0ep7vr8fpn">
      <div className="mx-auto max-w-4xl px-6 pb-11 pt-9 text-center sm:pt-12 lg:pb-14" data-id="element-93" data-mp="9l375k8q6q7o">
        <Pill tone="lime" data-id="element-94" data-mp="4n9wadwh9812">🏆 The Pickleball Instructor’s Vault™</Pill>

        <h1 className="mx-auto mt-5 max-w-3xl font-display text-[2.1rem] font-extrabold leading-[1.05] text-shell sm:text-5xl lg:text-[3.4rem]" style={{
        fontSize: "24px"
      }} data-id="element-95" data-mp="128frdnreylxt">
          Solve a Full Year of Professional Coaching in{' '}
          <span className="text-lime" data-id="element-96" data-mp="s9giq56neqat">Just 5 Minutes</span>
        </h1>

        {/* The complete product mockup sits directly under the hook. */}
        <img src={heroImage} alt="The complete Pickleball Instructor's Vault: six volumes, seven strategic bonuses and printable coaching resources." className="mx-auto mt-8 w-full max-w-[20rem] sm:max-w-md lg:max-w-2xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
        fetchpriority: 'high'
      }} data-id="element-97" data-mp="3d21tk0zn2qpb" />

        <p className="mx-auto mt-7 max-w-readable font-sans text-[0.98rem] leading-relaxed text-shell/75 sm:text-lg" style={{
        fontSize: "13px"
      }} data-id="element-98" data-mp="39aurjeh4toxr">
          150+ ready-to-teach lessons, 150+ elite drills and 7 strategic
          bonuses — the structured library that puts you on the court fully
          prepared and confident today.
        </p>

        <div className="mt-7" data-id="element-99" data-mp="35a2hij0frg0f">
          <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-100" data-mp="2qk3lalsfyenl">
            Get the complete Vault now
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-101" data-mp="2vjg5eyrxh7mh">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-xs text-shell/80" data-id="element-102" data-mp="2hl9sl6i8e8fb">
              <CheckIcon className="h-3.5 w-3.5 text-lime" strokeWidth={2.6} aria-hidden="true" data-id="element-103" data-mp="s2jnvz2aw4kk" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}